import { TpParameters } from '@/models/Part/TpParameters'
import { BasePicturesModel } from '@/models/BasePicturesModel'


export class GroupedSale extends BasePicturesModel {
	static fields () {
		return {
			id: null,
			type: null,
			name: null,
			estimatedSales: 0,
			department: null,
			sold: 0,
			soldWithoutVat: 0,
			// shipmentPrice: 0,
			profit: 0,
			cost: 0,
			lastSaleDate: null,
			partsCount: 0,
			hasParts: false,
			pictures: null,
			price: null,
			currency: null,
			currencyHistoryData: null,
			transportationPrice: null,
			disassemblyPrice: null,
			miscellaneousPrice: null,
			storagePrice: null,
			comment: null,
			status: null,
			vehicleSpecifications: TpParameters,
			deleteComment: null,
			colorCode: null,
			groupedSaleDraftId: null,
			createdAt: null,
			updatedAt: null,
			location: {
				id: null,
				name: null
			},
			user: {
				id: null,
				firstname: null,
				lastname: null
			}
		}
	}

	get manufacturer () {
		return this.vehicleSpecifications && this.vehicleSpecifications.manufacturer ? this.vehicleSpecifications.manufacturer.name : null
	}

	get model () {
		const model = this.vehicleSpecifications && this.vehicleSpecifications.model || null
		if (model) {
			return `${model.name}`
		}
		return null
	}

	get modification () {
		const modification = this.vehicleSpecifications && this.vehicleSpecifications.modification || null
		if (modification) {
			const startDate = modification.startDate ? modification.startDate.slice(0, 4) : '-'
			const endDate = modification.endDate ? modification.endDate.slice(0, 4) : '-'
			return `${modification.name} (${startDate} - ${endDate})`
		}
		return null
	}

	get title () {
		let title = ''
		if (this.manufacturer) {
			title += `${this.manufacturer} `
		}
		if (this.model) {
			title += `${this.model} `
		}
		if (this.modification) {
			title += `${this.modification} `
		}
		// if (this.bodyType) {
		// 	title += `${this.bodyType}/`
		// }
		return title || null
	}
}

export function createGroupedSale (data) {
	return Object.freeze(new GroupedSale(data))
}
